import React from 'react';
import './StatusBanner.css';
import DismissibleNotice from './DismissibleNotice';

function getVariant(kpis) {
  if (!kpis) return 'neutral';
  if (kpis.buy > 0) return 'success';
  if (kpis.investigate > 0) return 'warning';
  return 'neutral';
}

function formatTime() {
  const now = new Date();
  return now.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

export default function StatusBanner({ kpis }) {
  const variant = getVariant(kpis);

  const title = {
    success: `${kpis?.buy ?? 0} setup${(kpis?.buy ?? 0) !== 1 ? 's' : ''} sistêmico${(kpis?.buy ?? 0) !== 1 ? 's' : ''} confirmado${(kpis?.buy ?? 0) !== 1 ? 's' : ''} hoje`,
    warning: `${kpis?.investigate ?? 0} sinal${(kpis?.investigate ?? 0) !== 1 ? 'is' : ''} detectado${(kpis?.investigate ?? 0) !== 1 ? 's' : ''} — investigar antes de operar`,
    neutral: 'Nenhum setup hoje — mercado sem distorções extremas',
  }[variant];

  const icon = { success: '⚡', warning: '⚠', neutral: '🌙' }[variant];

  return (
    <DismissibleNotice
      noticeKey="daily-signal-summary"
      eventKey={`${variant}:${title}`}
      className={`sb-root sb-${variant}`}
      closeLabel="Fechar resumo diário"
      role="status"
    >
      <div className="sb-icon">{icon}</div>
      <div className="sb-body">
        <div className="sb-title">{title}</div>
      </div>
      <div className="sb-time">
        <div className="sb-live-dot" />
        <span>{kpis?.date ? new Date(kpis.date).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', timeZone: 'UTC' }) : formatTime()}</span>
      </div>
    </DismissibleNotice>
  );
}
